import Competitor from "./Competitor";

export default class CompetitionHelper {
  static competitorName = (competitors: Competitor[], id: number) => {
    return competitors.find(competitor => competitor.id === id)?.name;
  };
}
